export default __webpack_public_path__ + "static/design-pro-banner-a515d66fbc58e4d573424c7b3b222e37.png";